<script lang="ts">
    import type {OnCallDutySummary, SummaryPaymentState} from '../../../types';
    import {SummarySectionType} from '../../../types';
    import AttendanceSummarySection from '../AttendanceSummarySection.svelte';
    import AttendanceCell from '../../AttendanceCell.svelte';
    import AttendanceSummaryColumn from '../AttendanceSummaryColumn.svelte';

    export let onCallDuty: OnCallDutySummary;
    export let paymentState: SummaryPaymentState | null = null;
</script>

<AttendanceSummarySection type={SummarySectionType.ON_CALL_DUTY} {paymentState}>
    <AttendanceSummaryColumn>
        <AttendanceCell header>Celkový čas</AttendanceCell>
        <AttendanceCell durationItem={onCallDuty}/>
    </AttendanceSummaryColumn>
</AttendanceSummarySection>
